// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__7MnXnXwk","error":"Captcha_error__mRcEIkxY"};